import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ variables }) => ({
  list: {
    margin: 0,
    padding: variables?.spacingD,
    listStyle: 'none',
    '&.mobile': {
      paddingBottom: '72px',
    },
    '& li': {
      margin: `${variables?.spacingNone} ${variables?.spacingNone} ${variables?.spacingD}`,
      '&:last-child': {
        margin: 0,
      },
    },
  },
}));

export default styles;
